/* CoreReforme hero slider behaviour.
   Autoplay only starts after the first user interaction (pointer, key, scroll or touch).
   Reason: a carousel that rotates on its own keeps producing new Largest Contentful Paint
   candidates, which made the reported LCP ~7.4s even though the first slide painted at ~1.5s. */
(function () {
  function init(root) {
    if (!root || root.dataset.crInit) return;
    root.dataset.crInit = '1';
    var slides = root.querySelectorAll('.cr-hero__slide');
    var dots = root.querySelectorAll('.cr-hero__dot');
    if (slides.length < 2) return;

    var i = 0;
    var ms = (+root.dataset.speed || 6) * 1000;
    var timer = null;
    var started = false;

    function loadSlideImage(n) {
      var img = slides[n] && slides[n].querySelector('img[loading="lazy"]');
      if (img) { img.loading = 'eager'; img.fetchPriority = 'auto'; }
    }

    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      loadSlideImage(i);
      loadSlideImage((i + 1) % slides.length);
      slides[i].classList.add('is-active');
      if (dots[i]) { void dots[i].offsetWidth; dots[i].classList.add('is-active'); }
      restart();
    }

    function restart() {
      clearTimeout(timer);
      if (started && !root.classList.contains('is-paused')) {
        timer = setTimeout(function () { go(i + 1); }, ms);
      }
    }

    function start() {
      if (started) return;
      started = true;
      loadSlideImage(1);
      restart();
    }

    ['pointerdown', 'keydown', 'touchstart', 'wheel'].forEach(function (evt) {
      window.addEventListener(evt, start, { once: true, passive: true });
    });
    window.addEventListener('scroll', start, { once: true, passive: true });

    root.querySelectorAll('.cr-hero__arrow').forEach(function (b) {
      b.addEventListener('click', function () { start(); go(i + +b.dataset.dir); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { start(); go(+d.dataset.index); });
    });

    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); restart(); });

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { start(); go(i + (dx < 0 ? 1 : -1)); }
      x0 = null;
    });
  }

  function boot() { document.querySelectorAll('.cr-hero').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
